import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Divider } from "@material-ui/core";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Dprint from "./Exercise06/DDDPrinting";
import Dscan from "./Exercise06/DDDScanning";

const styles = theme => ({
  card: {
    minWidth: 275
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)"
  },
  title: {
    fontSize: 14
  },
  pos: {
    marginBottom: 12
  },
  root: {
    width: "100%"
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  }
});

class SimpleCard extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Card className={classes.card}>
          <CardContent>
            <Typography
              className={classes.title}
              color="textSecondary"
              gutterBottom
            >
              Feb 20, 2019
            </Typography>
            <Typography variant="h5" component="h2">
              3D Scanning and Printing
            </Typography>
            <Typography className={classes.pos} color="textSecondary">
              additive vs subtractive processes, printing, scanning
            </Typography>
            <Typography component="p">
              group assignment:
              <br />
              {'"test the design rules for your 3D printer(s)"'}
              <br />
              individual assignment:
              <br />
              {
                '"design and 3D print an object (small, few cm3, limited by printer time) that could not be made subtractively"'
              }
              <br />
              {'"3D scan an object (and optionally print it)"'}
            </Typography>
          </CardContent>
          <CardActions>
            <Button
              href="http://academy.cba.mit.edu/classes/scanning_printing/index.html"
              target="_blank"
              size="small"
            >
              Learn More
            </Button>
          </CardActions>
          <Divider />
        </Card>
        <br />
        <div className={classes.root}>
          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>3D Printing</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Dprint />
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
              <Typography className={classes.heading}>3D Scanning</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <Dscan />
            </ExpansionPanelDetails>
          </ExpansionPanel>
        </div>
      </div>
    );
  }
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(SimpleCard);
